/* ============================================================
   Selo "Novo" do menu lateral.

   É configuração, não estado: cada item guarda a data em que entrou no ar e o
   selo some sozinho quando passa a janela. Por não depender de banco nem de
   storage, o selo aparece e some no mesmo dia para a empresa inteira — e não
   sobra nada para limpar depois.

   Para parar de anunciar um item antes da hora, apague a linha dele.
   ============================================================ */

/** Por quantos dias o item fica marcado como novo. */
export const NEW_BADGE_DAYS = 30;

/** Caminho da rota -> data de lançamento (YYYY-MM-DD, hora local). */
export const NEW_MENU_ITEMS: Record<string, string> = {
    '/financial': '2026-08-14',
    '/task': '2026-08-14',
    '/ticket': '2026-08-17',
    '/utilitarian': '2026-08-21',
    '/downloads': '2026-08-24',
};

/**
 * O item ainda está dentro da janela de novidade?
 * `now` é injetável para dar para testar sem mexer no relógio da máquina.
 */
export const isNewMenuItem = (path: string, now: Date = new Date()): boolean => {
    const releasedAt = NEW_MENU_ITEMS[path];
    if (!releasedAt) return false;

    // Sem "Z" no fim: a data é lida no fuso local, como o resto do sistema.
    const released = new Date(`${releasedAt}T00:00:00`);
    if (Number.isNaN(released.getTime())) return false;

    const elapsedDays =
        (now.getTime() - released.getTime()) / (24 * 60 * 60 * 1000);

    // `>= 0` segura o caso de data futura: item agendado não pisca antes da hora.
    return elapsedDays >= 0 && elapsedDays < NEW_BADGE_DAYS;
};
